






















































































































































































































import _ from 'lodash';
import { Component, Mixins, Watch } from "vue-property-decorator";
import MenuSet from "@/model/menuSet";
import Menu from "@/model/menu";
import SetMenuItem from "@/model/setMenuItem";
import Order from "@/model/order";
import store from "@/store";
import {namespace} from "vuex-class";
import qNotify from "@/common/qNotify";
import NumberGenerator from "@/common/mixins/numberGenerator";
import AllYouCanEatDrink from "@/common/mixins/allYouCanDrinkEat";
import {NO_IMAGE_URL} from "@/common/constant";
import Option from "@/model/option";
import System from "@/model/system";

const orderStore = namespace("OrderStore");
const menuStore = namespace("MenuStore");
const optionStore = namespace("OptionStore");
const menuSetStore = namespace("MenuSetStore");
const systemStore = namespace("SystemStore");
const languageStore = namespace("LanguageStore")

@Component({
  name: "qDetailModal",
})
export default class qDetailModal extends Mixins(NumberGenerator, AllYouCanEatDrink) {
  @orderStore.Getter
  getOrderList!: Order[];
  @menuStore.Getter
  getMenuList!: Menu[];
  @optionStore.Getter
  getOptionList!: Option[];
  @menuSetStore.Getter
  getMenuSetList!: MenuSet[];
  @systemStore.Getter
  getSystem!: System;
  @languageStore.Getter
  getMenuNameKey: string

  public isShow = false;
  public isEdit = false;
  public isSubItem = false;
  public isDisabledAddButton = false;
  public isZeroPossibleItem = false;
  public isError = false;
  public isCantAddMenu = false;
  private fclose = false;
  public cantAddMenuErroMsg = '';
  public options: Option[] = [];
  public optionsInit: Option[] = [];
  public menuInit = new Menu();
  public menu = new Menu();
  public menuSetList: MenuSet[] = [];
  public menuSetListInit: MenuSet[] = [];
  public menuOptionList: SetMenuItem[] = [];
  public noImageUrl = NO_IMAGE_URL;

  mounted() {
    this.isError = false;
  }

  private get namekey() {
    return this.getMenuNameKey;
  }

  private closeEvent() {
    if (this.$router.currentRoute.hash != "#openDetail") {
      this.isShow = false;
      removeEventListener("popstate", this.closeEvent);
    }
  }

  @Watch("isShow")
  changeShow() {
    if (this.isShow) {
      addEventListener("popstate", this.closeEvent);
      this.$router.push({ "hash": "openDetail" });
    } else {
      if (this.$router.currentRoute.hash === "#openDetail") {
        this.$router.back();
      }
    }
  }

  /**
   * 親メニューまたはサブメニューの最大注文数
   */
  private get mostQuantity () {
    return _.max([
      this.menu.quantity,
      ..._.map(this.options, (option) => option.quantity)
    ]);
  }

  /**
   * 親メニューまたはサブメニューの合計注文数
   */
  private get total () {
    return _.max([
      this.menu.quantity,
      _.sum(_.map(this.options, (option) => option.quantity))
    ]);
  }

  /**
   * 注文種類数
   */
  private get count () {
    return _.max([
      1,
      _.filter(this.options, (option) => option.quantity > 0).length
    ]);
  }

  private isValidOrderLimitDrink(): boolean {
    /**
     * orderLimitDrink："7"
      →ドリンクメニューの中で7個以上メニューを頼めない
     */
    if (this.menu.foodKind != "2") {
      return true;
    }

    if (!this.getMenuSetting) {
      return false;
    }

    const orderLimitDrink =  Number.parseInt(this.getMenuSetting.orderLimitDrink);
    if (orderLimitDrink === 0) {
      return true;
    }

    const orderlist = _.filter(this.getOrderList, (order) => {
      return order.identifier != this.menu.identifier;
    });
    const orderDrinkCount = _.sum(
      _.map(
        _.filter(orderlist, (order: Order) => {
          return order.menuDetail.foodKind === "2";
        }), (order: Order) => {
          const subTotal = _.sumBy(order.subMenus, s => s.quantity);

          return _.max([order.quantity, subTotal])
        }
      )
    );

    return orderDrinkCount + this.total <= orderLimitDrink;
  }

  private isValidOrderLimitFood(): boolean {
    /**
     * orderLimitFood："6"
      →フードメニューの中で同じメニューを6個以上メニューを頼めない
     */
    if (this.menu.foodKind != "1") {
      return true;
    }

    if (!this.getMenuSetting) {
      return false;
    }

    const orderLimitFood = Number.parseInt(this.getMenuSetting.orderLimitFood);
    if (orderLimitFood === 0) {
      return true;
    }

    return this.mostQuantity <= orderLimitFood;
  }

  private isValidOrderLimitTotal(): boolean {
    /**
     * orderLimitTotal："10"
      →フードの中で10個以上メニューを頼めない
     */
    if (this.menu.foodKind != "1") {
      return true;
    }

    if (!this.getMenuSetting) {
      return false;
    }

    const orderLimitTotal = Number.parseInt(this.getMenuSetting.orderLimitTotal);
    if (orderLimitTotal === 0) {
      return true;
    }

    const orderlist = _.filter(this.getOrderList, (order) => {
      return order.identifier != this.menu.identifier;
    });
    const orderFoodCount = _.sum(
      _.map(
        _.filter(orderlist, (order: Order) => {
          return order.menuDetail.foodKind === "1";
        }), (order: Order) => {
          const subTotal = _.sumBy(order.subMenus, s => s.quantity);

          return _.max([order.quantity, subTotal])
        }
      )
    );

    return orderFoodCount + this.total <= orderLimitTotal;
  }

  private isValidOrderLimitType(): boolean {
    /**
     * orderLimitTyle："5"
      →フードの中で5種類以上メニューを頼めない
      　NG： 1.熟成ハラミ塩タレ（１）
      　　　　2.ぐりぐりカルビ塩ダレ（2）
      　　　　3.バラカルビ塩タレ（3）
      　　　　4.壺漬けハラミステーキ（1）
      　　　　5.絶品やみつきカルビ塩ダレ（1）
      　　　　ド.100円生ビール（1）
      　　　　6.やわらかカルビ（1）→ ×
     */
    if (this.menu.foodKind != "1") {
      return true;
    }

    if (!this.getMenuSetting) {
      return false;
    }

    const orderLimitType = Number.parseInt(this.getMenuSetting.orderLimitType);
    if (orderLimitType === 0) {
      return true;
    }

    const orderlist = _.filter(this.getOrderList, (order) => {
      return order.identifier != this.menu.identifier;
    });
    const orderFoodCount = _.sum(
      _.map(
        _.filter(orderlist, (order: Order) => {
          return order.menuDetail.foodKind === "1";
        }), (order: Order) => {
          const subTotal = _.filter(order.subMenus, s => s.quantity > 0).length;

          return _.max([1, subTotal])
        }
      )
    );

    return orderFoodCount + this.count <= orderLimitType;
  }

  public async show(data, isEdit = false) {
    const order = this.getOrderList
      .find((order) => data.identifier === order.identifier);
    let menu = data;
    if (order) {
      menu = { ...menu,...order }
      isEdit = true;
    }

    this.menu = JSON.parse(JSON.stringify(menu))
    this.menuSetList = [];
    this.options = []
    this.isEdit = isEdit
    this.isDisabledAddButton = false
    this.isZeroPossibleItem = false
    this.isError = false

    this.getOptionList.map(value => {
      if (value.identifier.toString() === menu.identifier.toString()) {
        this.options.push(JSON.parse(JSON.stringify(value)))
      }
    })

    if (this.options.length > 0) {
      this.isSubItem = true
      this.isDisabledAddButton = true
      this.checkOptions()
    }
    if (! this.menu.quantity) {
      const initQty = this.options.length === 0 ? 1 : 0;
      this.$set(this.menu, 'quantity', initQty);
    }
    this.optionsInit = JSON.parse(JSON.stringify(this.options))

    if (!this.isEdit) {
      this.getMenuSetList.map(setMenu => {
        if (setMenu.identifier === menu.identifier) {
          this.menuSetList.push(JSON.parse(JSON.stringify(setMenu)))
        }
      })
    } else {
      this.menu = JSON.parse(JSON.stringify(menu.menuDetail))
      this.getOrderList.map(item => {
        if (item.identifier === menu.identifier) {
          this.menuSetList = JSON.parse(JSON.stringify(item.options))
        }
      })
      this.menuSetListInit = JSON.parse(JSON.stringify(this.menuSetList));
    }

    this.isShow = true
    this.checkOptionHasPossibleItem()
    this.menuInit = JSON.parse(JSON.stringify(this.menu))
    if (this.hasQuantityError()) {
      this.fclose = true;
    }
  }

  private checkOptionHasPossibleItem() {
    this.menuSetList.filter(menu => {
      if (menu.possible_count_of_order === "0") {
        this.isZeroPossibleItem = true
      }
    })
  }

  closeErrorPopup() {
    this.isError = false;
  }

  private hasQuantityError() {
    let hasError = true;
    switch (false) {
    case this.isValidOrderLimitDrink():
      this.cantAddMenuErroMsg = this.$t('一度に注文できるのは').toString() + '<br>';
      this.cantAddMenuErroMsg += this.$t('{text}品までです。', { 'text': this.getMenuSetting.orderLimitDrink }).toString() + '<br>';
      this.cantAddMenuErroMsg += this.$t('一度注文を送信してください。').toString();
      break;
    case this.isValidOrderLimitFood():
      this.cantAddMenuErroMsg = this.$t('一度に注文できるのは').toString() + '<br>';
      this.cantAddMenuErroMsg += this.$t('{text}品までです。', { 'text': this.getMenuSetting.orderLimitFood }).toString() + '<br>';
      this.cantAddMenuErroMsg += this.$t('一度注文を送信してください。').toString();
      break;
    case this.isValidOrderLimitTotal():
      this.cantAddMenuErroMsg = this.$t('注文数の合計が「{text}」になるようにしてください', {'text': this.getMenuSetting.orderLimitTotal}).toString();
      break;
    case this.isValidOrderLimitType():
      this.cantAddMenuErroMsg = this.$t('一度に注文できる種類は').toString() + '<br>';
      this.cantAddMenuErroMsg += this.$t('{text}種類までです。', { 'text': this.getMenuSetting.orderLimitType }).toString() + '<br>';
      this.cantAddMenuErroMsg += this.$t('一度注文を送信してください。').toString();
      break;
    default:
      hasError = false;
      break;
    }
    if (hasError) {
      this.isCantAddMenu = true;
    }
    return hasError;
  }

  checkOptions() {
    let total = 0
    if (this.options.length > 0) {
      this.options.filter(option => {
        total += option.quantity
      })

      this.isDisabledAddButton = !(total > 0)
    }
  }

  public async cancel() {
    this.isShow = false;
    this.isSubItem = false
    this.menuOptionList = []
    this.options = []

    if (this.optionsInit.length > 0) {
      this.optionsInit.map(option => {
        store.dispatch('OptionStore/editOptionToList', option)
      })
    }
    store.dispatch('MenuStore/editMenuToList', this.menuInit)

    if (this.isEdit) {
      this.menuSetList = this.menuSetListInit
    }
  }

  public async removeToCart(menu) {
    this.isShow = false;
    this.isSubItem = false
    this.options = []
    let indexRemove = null
    this.getOrderList.map((value, key) => {
      if (value.identifier === menu.identifier) {
        indexRemove = key
      }
    })
    if (indexRemove !== null) {
      store.dispatch('OrderStore/removeOrderInList', indexRemove)
    }

    if (this.optionsInit.length > 0) {
      this.optionsInit.map(option => {
        option.quantity = 1
        store.dispatch('OptionStore/editOptionToList', option)
      })
    }
    this.menuInit.quantity = 1
    store.dispatch('MenuStore/editMenuToList', this.menuInit)
  }

  public async addToCart(order, menuSetList,  isEdit = false) {
    if (this.hasQuantityError()) {
      return;
    }
    const oldQuantity = order.quantity
    let sumQuantity = 0;
    let parameters = {
      "act": "register",
      "mtd": "register",
      "name": order.name,
      "name_cn": order.name_cn,
      "name_kr": order.name_kr,
      "name_en": order.name_en,
      "quantity": order.quantity,
      "orderTime": "",
      "subIdentifier": "0",
      "price": order.price,
      "rowTotalPrice": 0,
      "isHaizen": "",
      "options": menuSetList,
      "subMenus": this.options,
      "identifier": order.identifier,
      "menuDetail": order,
    };

    if (this.options.length > 0 && this.isSubItem) {
      this.options.map(option => {
        sumQuantity += option.quantity
      })
    }

    const hasErrorOption0 = menuSetList
      .map((menuSet) => {
        if (menuSet.possible_count_of_order !== "0") {
          return false;
        }
        // eslint-disable-next-line unicorn/no-array-reduce
        const sum = menuSet.options.reduce((sum, option) => sum + option.quantity, 0);
        return sum !== order.quantity;
      })
      .filter(result => result)
      .length > 0;
    if (this.isZeroPossibleItem && hasErrorOption0) {
      this.isSubItem = false
      this.isError = true
      this.options = []
      return;
    }

    if (this.isSubItem) {
      if ( isEdit ) {
        order.quantity = (this.options.length > 0 && this.isSubItem) ? (oldQuantity - (oldQuantity - sumQuantity)) : order.quantity
      } else {
        order.quantity = (this.options.length > 0 && this.isSubItem) ? sumQuantity : order.quantity
      }
    }

    parameters = {
      ...parameters, ...{
        "quantity": order.quantity,
        "menuDetail": order,
      }
    }

    if (order.quantity <= 0 || typeof order.quantity === "undefined") {
      qNotify.error({
        text: 'メニューの選択数は 1 以上を選択してください。',
      });
    } else {
      if ( isEdit ) {
        store.dispatch('OrderStore/editOrderToList', new Order(parameters));
      } else {
        if (await this.validate(order)) {
          store.dispatch('MenuStore/editMenuToList', this.menuInit)
          this.setDefaultOptions()
          qNotify.error({
            text: 'The order is valid',
          });
        } else {
          store.dispatch('OrderStore/addOrderToList', new Order(parameters));
          store.dispatch('MenuStore/editMenuToList', order)
        }
      }
    }

    this.isShow = false;
    this.isSubItem = false
    this.options = []
  }

  private setDefaultOptions() {
    this.optionsInit.map(option => {
      store.dispatch('OptionStore/editOptionToList', option)
    })
  }

  private async validate(order) {
    let invalid = false;
    this.getOrderList.map(value => {
      if (value.identifier === order.identifier) {
        invalid = true;
      }
    })

    return invalid;
  }

  public addQuantityModal(item: Menu, isMenu = false) {
    item.quantity++
    if (this.hasQuantityError()) {
      item.quantity--;

      return;
    }
    if(item.quantity < item.minimumOrder) {
      item.quantity = item.minimumOrder;
    }

    this.updateModule(item, isMenu)
    this.checkOptions()
  }

  public subQuantityModal(item: Menu, isMenu = false) {
    item.quantity--
    if(item.quantity < item.minimumOrder) {
      item.quantity = item.minimumOrder;
    }
    this.updateModule(item, isMenu)
    this.checkOptions()
  }

  public isDisableStatusOptionModal(item, menu) {
    let menuQuantity = 0
    menu.options.filter(option => {
      menuQuantity += option.quantity
    })

    if (menu.possible_count_of_order === "0") {
      return menuQuantity >= this.menu.quantity;
    } else if (menu.possible_count_of_order === "99") {
      return item.quantity >= 99;
    } else {
      return menuQuantity >= menu.possible_count_of_order;
    }
  }

  updateModule(item, isMenu) {
    if (isMenu) {
      store.dispatch('MenuStore/editMenuToList', new Menu({
        ...item, ...{
          quantity: item.quantity
        }
      }))
    } else {
      store.dispatch('OptionStore/editOptionToList', new Option({
        ...item, ...{
          quantity: item.quantity
        }
      }))
    }
  }

  public isDisableStatusModal(item: Menu, isOption = false, isSetMenu = false) {
    if (isOption) {
      return item.quantity < item.minimumOrder || item.quantity === 0;
    } else if (isSetMenu) {
      return item.quantity < item.minimumOrder || item.quantity === 0;
    }
    return item.quantity < item.minimumOrder || item.quantity === 1;
  }


  getPossibleNumber(menu) {
    if (!this.isDisplayPossibleNumber(menu)) return ;

    let quantityCheck = 0;
    menu.options.filter(option =>{
      quantityCheck += option.quantity
    })

    if (menu.possible_count_of_order === '0') {
      if (quantityCheck > 0) return this.menu.quantity - quantityCheck
      return this.menu.quantity
    } else {
      if (quantityCheck > 0) return menu.possible_count_of_order - quantityCheck
      return menu.possible_count_of_order
    }
  }

  public closeCantAddMenuErrorPopup() {
    if (this.fclose) {
      this.isShow = false;
    }
    this.isCantAddMenu = false;
    this.fclose = false;
  }

  isDisplayPossibleNumber(menu) {
    return !(menu.possible_count_of_order === '99');
  }

  getOptionText(possibleCountOfOrder) {
    return (possibleCountOfOrder === "0") ? "必須"  : "任意";
  }
}
